import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Switch, Spin } from 'antd';

type FormValues = {

    data: string;
};

const CustomBogQueryTest: React.FC = () => {
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const defaultValues = {
  
        data: ""
    }
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>({
        defaultValues
    });

    const onSubmit = async (data: FormValues) => {
        setLoading(true)
       
        await fetch(`${window.location.origin}/api/v1/test-custom-bigquery-screen`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: data?.data,
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false)
                setData(data)
            })
            .catch((error) => {
                console.error("Error:", error);
                setLoading(false)
            })

    };

    return (

        <div className="grid grid-cols-2 border mt-3">
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: 10, borderRight: "1px solid grey" }}>
                <div>
                <label>
                  Custom Big Query Data Object
                </label>
                    <textarea  {...register("data", { required: "Data is required" })} style={{border:"1px solid",width:"100%",minHeight:"200px"}}/>
                    {errors.data && <p className="text-red-500 text-sm">{errors.data.message}</p>}
                </div>
 

                <button type="submit" className="bg-[#4C8067] h-11 text-white font-semibold" disabled={loading}>{loading ? "Loading" : "Submit"}{loading && <Spin style={{ color: "#FFFFFF" }} />}</button>
            </form>
            <div className="p-3">
                <p>Results:</p>
                {
                    loading ? (
                        <div className="flex justify-center items-center">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <pre className="text-sm text-wrap">{JSON.stringify(data, null, 2)}</pre>
                    )
                }
            </div>
        </div>
    );
};

export default CustomBogQueryTest;
